import React, { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa"; // Import the success icon
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import Loader from "../reusble_components/loader";
import { apiGet } from "../../api/api_methods";
import { MdClose, MdWatchLater } from "react-icons/md";
import { useStores } from "../../store";

const PaymentSuccess = ({ id }) => {
  const [loading, setloading] = useState(false);
  const [paymentStatus, setpaymentStatus] = useState(null);
  const [orderId, setorderId] = useState(id);
  const [isStudent, setIsStudent] = useState(false);
  // Generate a sample order ID (replace this with your actual order ID logic)
  const location = useLocation(); // Get the current URL location
  const query = queryString.parse(location.search);
  const cluster = query.cluster;
  const { InterviewStore, UserStore } = useStores();
  // const gateWay = query.gateway;

  const checkUserRole = (roleId) => {
    // Student role ID from the example data
    const STUDENT_ROLE_ID = "647ce2e8c41bee677ea39fc4";
    return roleId === STUDENT_ROLE_ID ? "user" : "company";
  };

  const fetchOrderDetails = async () => {
    const subscription = localStorage.getItem("subscription");
    // get the order id from the url
    const order_id = window.location.pathname.split("/")[2];
    setorderId(order_id);
    // get the query params from the url
    setloading(true);
    let role = "user"; // Default role
    if (subscription === "true") {
      const paymentSubUrl =
        cluster === "668d072fb65d4ae6cb2b9101"
          ? "/phonepe-payment/verify-payment-for-subscription"
          : "/phonepe/verify-subscription-payment";
      const paymentResponse = await apiGet(`${paymentSubUrl}/${order_id}`);
      localStorage.removeItem("subscription");
      setloading(false);
      console.log(paymentResponse);
      if (paymentResponse) {
        // Check if user is a student
        if (paymentResponse?.body?.data?.userId?.role?._id) {
          role = checkUserRole(paymentResponse.body.data.userId.role._id);
        }

        if (paymentResponse?.body?.data?.paymentStatus === "PAYMENT_SUCCESS") {
          navigate(
            `/subscription/successfull?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_PENDING"
        ) {
          navigate(
            `/subscription/pending?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_ERROR"
        ) {
          navigate(
            `/subscription/failed?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        }
        setpaymentStatus(paymentResponse?.body?.data?.paymentStatus);
        UserStore.getUserDetails();
      } else {
        if (paymentResponse?.body?.data?.paymentStatus === "PAYMENT_SUCCESS") {
          navigate(
            `/subscription/successfull?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_PENDING"
        ) {
          navigate(
            `/subscription/pending?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_ERROR"
        ) {
          navigate(
            `/subscription/failed?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        }
        // alert(paymentResponse?.body?.message);
        return setpaymentStatus("failed");
      }
    } else {
      const paymentSubUrl =
        cluster === "668d072fb65d4ae6cb2b9101"
          ? "/phonepe-payment/verify-payment"
          : "/phonepe/verify-payment";

      const paymentResponse = await apiGet(`${paymentSubUrl}/${order_id}`);
      setloading(false);
      console.log(paymentResponse);
      if (paymentResponse) {
        if (paymentResponse?.body?.data?.userId?.role?._id) {
          role = checkUserRole(paymentResponse.body.data.userId.role._id);
        }
        if (paymentResponse?.body?.data?.paymentStatus === "PAYMENT_SUCCESS") {
          navigate(
            `/subscription/successfull?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_PENDING"
        ) {
          navigate(
            `/subscription/pending?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&paymentLink=${paymentResponse?.body?.data?.paymentLink}&role=${role}`
          );
        } else if (
          paymentResponse?.body?.data?.paymentStatus === "PAYMENT_ERROR"
        ) {
          navigate(
            `/subscription/failed?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}&role=${role}`
          );
        }
        // if (paymentResponse?.body?.message === "Payment Failed") {
        //   navigate(
        //     `/subscription/failed?planName=${paymentResponse?.body?.data?.subscriptionId?.planId?.name}&transactionId=${paymentResponse?.body?.data?.orderId}`
        //   );
        //   return;
        // }
        // alert(paymentResponse?.body?.message);
        return setpaymentStatus("failed");
      }
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const navigate = useNavigate();

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
      <Loader loader={loading} />

      {loading && (
        <p onClick={reloadPage} className="hover:text-blue-500 mt-[20vh] ">
          Refresh the page if it takes too long
        </p>
      )}
      {paymentStatus === "PAYMENT_SUCCESS" && (
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />

          <h1 className="text-3xl font-bold text-gray-800">
            Payment Successful
          </h1>

          <p className="text-lg text-gray-600 my-4">
            {isStudent
              ? `Your payment for Order #${orderId} has been successfully processed. You can now access your student features.`
              : `Your payment for Order #${orderId} has been successfully processed. You can now access your company features.`}
          </p>

          <button
            onClick={() => {
              UserStore.getTransactions();
              if (localStorage.getItem("redirectUrl")) {
                window.location.href = localStorage.getItem("redirectUrl");
                localStorage.removeItem("redirectUrl");
              } else {
                navigate("/");
              }
            }}
            className="bg-primary bg-opacity-80 text-white px-6 py-2 rounded-full hover:bg-primary focus:outline-none"
          >
            Back
          </button>
        </div>
      )}
      {paymentStatus === "failed" && (
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <MdClose className="text-red-500 text-5xl mx-auto mb-4" />

          <h1 className="text-3xl font-bold text-gray-800">Payment Failed</h1>

          <p className="text-lg text-gray-600 my-4">
            Your payment for Order #{orderId} has been failed.
          </p>

          <button
            onClick={() => {
              UserStore.getTransactions();
              if (localStorage.getItem("redirectUrl")) {
                window.location.href = localStorage.getItem("redirectUrl");
                localStorage.removeItem("redirectUrl");
              } else {
                navigate("/");
              }
            }}
            className="bg-primary bg-opacity-80 text-white px-6 py-2 rounded-full hover:bg-primary focus:outline-none"
          >
            Back
          </button>
        </div>
      )}
      {paymentStatus === "pending" && (
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <MdWatchLater className=" text-amber-500 text-5xl mx-auto mb-4" />

          <h1 className="text-3xl font-bold text-gray-800">Payment Pending</h1>

          <p className="text-lg text-gray-600 my-4">
            Your payment for Order #{orderId} is pending.
          </p>

          <button
            onClick={() => {
              UserStore.getTransactions();
              if (localStorage.getItem("redirectUrl")) {
                window.location.href = localStorage.getItem("redirectUrl");
                localStorage.removeItem("redirectUrl");
              } else {
                navigate("/");
              }
            }}
            className="bg-primary bg-opacity-80 text-white px-6 py-2 rounded-full hover:bg-primary focus:outline-none"
          >
            Back
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
